import ZZAPP from '@zz-common/native-adapter'
import isZZ from './isZhuanzhuan'
import VARS from '@/lib/vars'

const toRealPx = function (pt) {
  return (pt / 750) * document.documentElement.getBoundingClientRect().width
}

const isLogin = () => {
  return ZZAPP.isLogin()
}

const plugins = {
  ZZAPP,
  isZZ,
  isZZMP: VARS.isWXWebviewFn(),
  toRealPx,
  isIphoneX: VARS.isIphoneX,
  isAndroid: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1,
  isIos: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
  isLogin
}

export default {
  install(Vue) {
    for (const key in plugins) {
      Vue.prototype['$' + key] = plugins[key]
    }
  }
}
